import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
  PLACE_SERVICE_GROUPS,
  PlaceServiceDefinition,
} from '../../models/place.services';

interface VisibleServiceGroup {
  field: string;
  title: string;
  isDine: boolean;
  items: PlaceServiceDefinition[];
}

/**
 * Visitor-facing renderer for the place service groups (dine, accessibility,
 * payment, parking), driven by the same PLACE_SERVICE_GROUPS definitions the
 * dashboard Edit Services modal edits. Renders nothing when the place has no
 * services set.
 */
@Component({
  selector: 'ig-place-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './place.services.display.component.html',
})
export class PlaceServicesDisplayComponent implements OnChanges {
  @Input() place: any;
  // the section above the first group differs per host (e.g. Opening Hours in
  // the AI buddy card), so the host decides whether the first group needs a divider
  @Input() firstSectionBorder = false;

  groups: VisibleServiceGroup[] = [];

  ngOnChanges() {
    const place = this.place || {};
    this.groups = PLACE_SERVICE_GROUPS.map((group) => {
      const source = place[group.field] || {};
      return {
        field: group.field,
        title: group.visitorTitle,
        isDine: group.field === 'dine',
        items: group.definitions.filter((x) => source[x.key]),
      };
    }).filter((group) => group.items.length > 0);
  }
}
